<template>
  <div class="block" style="height: 50vh;overflow-y: auto">
    <el-timeline>
      <el-timeline-item
          :key="index"
          v-for="(activity, index) in actionList">

        <div>
          <el-row>
            <el-col :span="3">{{ activity.startTime }}分钟后</el-col>
            <el-col :span="19" style="color: #3a8ee6">每隔{{ activity.intervalTime }}分钟,共{{ activity.time }}次</el-col>
          </el-row>
          <el-row style="margin-top: 15px;margin-bottom: 30px;">
            <el-col :span="3">发消息给</el-col>
            <el-col :span="19">
              <el-col :span="24">
                <span :key="key" v-for="(value,key) in activity.alarmUpgradeNoticeMap">
                  通过<span :key="type.id" v-for="(type,index) in value">{{ type.noticeName }}<span
                    v-if="index !== value.length -1">,</span></span>方式给{{ key }}发送告警通知.
                </span>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  name: "UpgradeDetails",
  props: {
    actionList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.el-timeline >>> .el-timeline-item__tail {
  padding-bottom: 40px;
}

.el-timeline >>> .el-timeline-item__content {
  padding-top: 2px;
}
</style>